var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('app-layout',{attrs:{"bg":"gray-100"}},[_c(_vm.isAuthenticated ? 'user-home' : 'guest-home',{tag:"component"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }